import { createSlice } from '@reduxjs/toolkit';

export const friendRequestSlice = createSlice({
    name: 'friendRequest',
    initialState: {
        // Incremented each time a friend-request notification arrives.
        // FriendRequestAccept watches this and re-fetches when it changes.
        refreshTrigger: 0,
    },
    reducers: {
        FRIEND_REQUEST_RECEIVED: (state) => {
            state.refreshTrigger += 1;
        },
    }
});

export const { FRIEND_REQUEST_RECEIVED } = friendRequestSlice.actions;
export default friendRequestSlice.reducer;
